/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var E,I;!function(E){E[E.ADD=0]="ADD",E[E.UPDATE=1]="UPDATE",E[E.REMOVE=2]="REMOVE"}(E||(E={})),function(E){E[E.NONE=0]="NONE",E[E.VISIBILITY=1]="VISIBILITY",E[E.GEOMETRY=2]="GEOMETRY",E[E.TRANSFORMATION=4]="TRANSFORMATION",E[E.HIGHLIGHT=8]="HIGHLIGHT",E[E.OCCLUDEE=16]="OCCLUDEE"}(I||(I={}));export{E as DirtyOperation,I as DirtyState};
